import { render, staticRenderFns } from "./FileUploader.vue?vue&type=template&id=4c62fb9a&scoped=true&"
import script from "./FileUploader.vue?vue&type=script&lang=js&"
export * from "./FileUploader.vue?vue&type=script&lang=js&"
import style0 from "./FileUploader.vue?vue&type=style&index=0&id=4c62fb9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c62fb9a",
  null
  
)

export default component.exports
import {QFile,QIcon,QChip,QLinearProgress,QAvatar,QSpinner,QBtn,QSpace,QField} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QFile,QIcon,QChip,QLinearProgress,QAvatar,QSpinner,QBtn,QSpace,QField})
